import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly snackBar = inject(MatSnackBar);
  private readonly translate = inject(TranslateService);

  success(messageKey: string): void {
    this.open(messageKey, 3000, 'snackbar-success');
  }

  error(messageKey: string): void {
    this.open(messageKey, 5000, 'snackbar-error');
  }

  private open(messageKey: string, duration: number, panelClass: string): void {
    this.snackBar.open(this.translate.instant(messageKey), 'OK', { duration, panelClass });
  }
}
